import React, { FC } from 'react';
import { Row } from 'ia-react-core';
import { News } from '../../interfaces/News';
import Section from './Section';
import { StyledCol } from './Content.styles';

export interface ContentProps { isAllNews: boolean; news: News[]; currentPage: number}

const Content: FC<ContentProps> = ({ isAllNews, news, currentPage }) => {
  if (!news) return null;
  const newsListIndex = isAllNews ? news.length : 3;
  return (
    <Row gutterWidth={16} data-testid="ContentNewsRow">
      {news.slice(0, newsListIndex).map((n) => (
        <StyledCol isallnews={isAllNews?.toString()} m-b={isAllNews ? 16 : 0} xs={12} lg={4} key={n.id}>
          <Section currentPage={currentPage} news={n} isAllNews={isAllNews} />
        </StyledCol>
      ))}
    </Row>
  );
};

export default Content;
